import { render } from "./AllCompanyURIndex.vue?vue&type=template&id=788c50e5"
import script from "./AllCompanyURIndex.vue?vue&type=script&lang=js"
export * from "./AllCompanyURIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__